import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import { ForeignBusinessConferencesModel } from './types';
import foreignBusinessConferencesItemValidator from './validators/item';

const foreignBusinessConferencesValidator: ValidateJSModel<ForeignBusinessConferencesModel> = {
  HasForeignConferences: { hasValue: { validator: hasYesOrNo } },

  List: (value, attributes) => {
    if (attributes?.HasForeignConferences?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: foreignBusinessConferencesItemValidator },
      };
    }

    return {};
  },
};

export default foreignBusinessConferencesValidator;
